import { Outlet } from 'react-router-dom';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { paths } from '../../config/paths';
import Layout from '../../components/Layout/Layout';

export const AppRoot = () => {
    return (
        <Layout>
            <Outlet />
        </Layout>
    );
};


export const AppRootErrorBoundary = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // ルートパス（/）以外でエラーが発生した場合はリダイレクト
        if (location.pathname !== '/') {
            navigate(paths.home.path);
        }
    }, [navigate, location]);

    return <div>Something went wrong.</div>;
};